import { FontWeight, Heading, HeadingVariant } from '@lili/lili-frontend-common';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigationManager } from '@Router/useNavigationManager';
import { Icon, Icons } from '@Components/icon/Icon';
import { RoutesMap } from '@Router/router.types';
import { PasswordInput } from '@Components/inputs/PasswordInput';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { StepFooter } from './shared/StepFooter';
import { useRecoveryPasswordLogic } from './hooks/useRecoveryPasswordLogic';
import { MobileBackButton } from './shared/MobileBackButton';

export const RecoverySetPassword = () => {
  const {
    formMethods,
    isLengthValid,
    isAtLeastOneCapital,
    isAtLeastOneLowerCase,
    isAtLeastOneNumber,
    hintStyles,
    handleSubmit,
  } = useRecoveryPasswordLogic();
  const { navigateToSpecificPage } = useNavigationManager();
  const { t } = useTranslation();
  const { isMobile } = useResizeListener();
  return (
    <div className='recovery-page-container'>
      <MobileBackButton />
      <div className='flex flex-col pt-[56px] md:pt-[0px] w-full md:w-[520px] px-[24px] md:px-[42px] items-center'>
        <Icon icon={Icons.Shield} className='w-[90px] mb-[40px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header mb-[40px]'>
          {t('recovery.setPassword.title')}
        </Heading>

        <div className='w-full'>
          <FormProvider {...formMethods}>
            <PasswordInput hideHints />
          </FormProvider>
        </div>

        <div className={hintStyles}>
          <div className='flex items-center gap-2'>
            <Icon icon={isLengthValid ? Icons.ValidDataCheck : Icons.InvalidDataCheck} />
            <Heading.H9 fontWeight={FontWeight.REGULAR}>
              {t('recovery.setPassword.hint1')}
            </Heading.H9>
          </div>

          <div className='flex items-center gap-2'>
            <Icon icon={isAtLeastOneCapital ? Icons.ValidDataCheck : Icons.InvalidDataCheck} />
            <Heading.H9 fontWeight={FontWeight.REGULAR}>
              {t('recovery.setPassword.hint2')}
            </Heading.H9>
          </div>

          <div className='flex items-center gap-2'>
            <Icon icon={isAtLeastOneLowerCase ? Icons.ValidDataCheck : Icons.InvalidDataCheck} />
            <Heading.H9 fontWeight={FontWeight.REGULAR}>
              {t('recovery.setPassword.hint3')}
            </Heading.H9>
          </div>
          <div className='flex items-center gap-2'>
            <Icon icon={isAtLeastOneNumber ? Icons.ValidDataCheck : Icons.InvalidDataCheck} />
            <Heading.H9 fontWeight={FontWeight.REGULAR}>
              {t('recovery.setPassword.hint4')}
            </Heading.H9>
          </div>
        </div>

        <StepFooter
          id='reset-password-request'
          title={t('recovery.shared.footerContinue')}
          onClick={handleSubmit}
          onBackClick={() => navigateToSpecificPage(RoutesMap.WELCOME)}
          disabled={!formMethods.formState.isValid}
        />
      </div>
    </div>
  );
};
